export const joditConfig = {
    readonly: false,
    height: 300,
    toolbar: true,
    spellcheck: false,
    language: "en",
    toolbarButtonSize: "medium",
    toolbarAdaptive: false,
    showCharsCounter: true,
    showWordsCounter: true,
    showXPathInStatusbar: false,
    askBeforePasteHTML: true,
    askBeforePasteFromWord: true,
    buttons: [
        "source",
        "|",
        "bold", "strikethrough", "underline", "italic",
        "|",
        "ul", "ol",
        "|",
        "outdent", "indent",
        "|",
        "font", "fontsize", "brush", "paragraph",
        "|",
        "image", "link", "table",
        "|",
        "align", "undo", "redo",
        "|",
        "hr", "eraser", "copyformat",
        "|",
        "symbol", "fullsize", "preview", 
        "superscript", "subscript",
        "|",
        "selectall"
    ],
    
      
    uploader: {
        insertImageAsBase64URI: false
    },
    removeButtons: ["file"],
    disablePlugins: ["paste", "stat"]
};